import { type } from "arktype";

import { BOOLEAN_YES, FIELDS, type Draft } from "./fields";
import { fieldError } from "./validation";

function field(key: keyof Draft) {
	const definition = FIELDS.find((field) => field.key === key);

	if (definition === undefined) {
		throw new Error(key);
	}

	return type("string").narrow((value, ctx) => {
		const error = fieldError(definition, value);

		return error === null || ctx.mustBe(error);
	});
}

const form = type({
	name: field("name"),
	birth_date: field("birth_date"),
	cpf: field("cpf"),
	rg: field("rg"),
	mother_name: field("mother_name"),
	phone: field("phone"),
	email: field("email"),
	preferred_channel: field("preferred_channel"),
	cep: field("cep"),
	address_number: field("address_number"),
	"address_complement?": field("address_complement"),
	occupation: field("occupation"),
	marital_status: field("marital_status"),
	has_insurance: field("has_insurance"),
	"insurance?": "string",
	"how_found?": field("how_found"),
	"how_found_other?": field("how_found_other"),
	photo: field("photo"),
	accept: "boolean",
	hp: "string",
}).narrow((values, ctx) => {
	if (values.has_insurance !== BOOLEAN_YES || values.insurance?.trim().length) {
		return true;
	}

	return ctx.mustBe("Qual plano?");
});

export const FichaFormSchemas = { form };

export type FichaFormValues = typeof FichaFormSchemas.form.infer;
